<template>
    <div class="service-form-form">
        <p>Onarılmak üzere Arena Teknik Servisi'ne teslim ettiğiniz ürünlerin durumunu gerçek zamanda takip edebilirsiniz.</p>
        <b-overlay :show="isLoading" opacity="0.5">
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(handleQuery)">
                    <validation-provider
                    name="query"
                    :rules="{ required: true, min: 3 }"
                    v-slot="validationContext"
                    >
                        <b-form-group
                            id="fieldset-2"
                            description="Teknik servisimizde bulunan, sorgulamak istediğiniz ürünün arıza form, irsaliye, gelen kargo, ürün seri veya IMEI numarasını girin."
                            label="Arıza Form, İrsaliye, Gelen Kargo, Ürün Seri veya IMEI Numarası"
                            label-for="serviceFormQueryTxt"
                        >
                            <b-input-group >
                                <b-form-input 
                                    ref="serviceFormQueryTxt" 
                                    id="serviceFormQueryTxt" 
                                    v-model="query" 
                                    trim  
                                    :state="getValidationState(validationContext)"
                                    autocomplete="off"
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="info" @click="resetQuery"><v-icon name="times" /></b-button>
                                    <b-button type="submit" variant="info" ><v-icon name="search" /></b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </validation-provider>          
                </b-form>
            </validation-observer>
        </b-overlay>
    </div>
</template>

<script>
    export default {
        name: 'ServiceFormForm',
        data() {
            return {
                uriAfterSales: process.env.VUE_APP_URI_ARENA_API_AFTERSALES,
                isLoading: false,
                query: ''
            }
        },
        methods: {
            async handleQuery() {
                this.isLoading = true;
                this.$emit('QueryResponse', null);
                this.$emit('QueryRequest', { from: 'ServiceFormForm', query: this.query, icon: 'tools', tabIndex: 0 });
                await this.$recaptchaLoaded();
                const token = await this.$recaptcha('ServiceFormForm');
                fetch(`${this.uriAfterSales}/ServiceFormDetail?recaptchaToken=${token}&formNoOrSerialNo=${this.query}`)
                .then(res => { return res.json(); })
                .then(data => {
                    this.$emit('QueryResponse', data);
                    this.isLoading = false;
                });
            },
            resetQuery() {
                this.query = '';
                this.$emit('QueryResponse', null);
                this.$nextTick(() => {
                    this.$refs.observer.reset();
                });
            },
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            }
        }
    }
</script>

<style scoped>

</style>